import { useState, useEffect } from 'react';

import { DemoData } from '../types';

const useDemoData = () => {
  const [demoData, setDemoData] = useState<DemoData>(
    JSON.parse(localStorage.getItem('demoData') ?? '{}'),
  );

  useEffect(() => {
    const handler = () =>
      setDemoData(JSON.parse(localStorage.getItem('demoData') ?? '{}'));

    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const updateDemoData = (data: DemoData) => {
    localStorage.setItem('demoData', JSON.stringify(data));
    window.dispatchEvent(new Event('storage'));
  };

  const resetDemoData = () => {
    localStorage.removeItem('demoData');
    window.dispatchEvent(new Event('storage'));
  };

  return { demoData, updateDemoData, resetDemoData };
};

export default useDemoData;
